import ScrollToTop from './components/ScrollToTop';
import Header from './Header';
import { Outlet } from "react-router-dom";
import './scss/Root.scss';
import './scss/Dark.scss';

function Root() {

  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Outlet />
      </main>
    </>
  );
}

export default Root;
